import _RentalMastersService from "../services/rental-masters-service";
import { IRentalMastersService } from "../types/services/rental-masters-service";

const RentalMastersService: IRentalMastersService = new _RentalMastersService();

export default RentalMastersService;
